import React from 'react'
import PropTypes from 'prop-types'
import {Button, Input, Radio} from 'antd'

import {PER_PAGE} from '.'
import RenderPhotos from './RenderPhotos'
import PhotoGallery from 'shared/components/PhotoGallery'

const SEASONS = [
  { label: 'Alle', value: '' },
  { label: 'Sommer', value: 'summer' },
  { label: 'Høst', value: 'fall' },
  { label: 'Vinter', value: 'winter' },
  { label: 'Vår', value: 'spring' },
]

class AreaPhotosView extends React.Component {
  state = {
    isFullscreen: false,
    initialImageIndex: null,
  }

  handleSearchChange(obj) {
    this.props.updatePhotoSearch({...obj, photos: [], page: 1})
  }

  fetchMorePhotos() {
    const page = this.calculateNextPage()
    this.props.onLoadMore(page)
  }

  calculateNextPage() {
    let page = 1
    page = Math.ceil(this.props.photos.length / PER_PAGE + 1)
    if (page < 1) page = 1
    return page
  }

  photoClicked({photoIndex}) {
    this.setState({
      isFullscreen: true,
      initialImageIndex: photoIndex,
    })
  }

  closeFullscreen = () => {
    this.setState({isFullscreen: false})
  }

  getGalleryImages = () => {
    return this.props.photos.map(({node}) => node)
      .filter(n => n.image)
      .map(n => n.image.url)
  }

  render() {
    const {
      isFullscreen,
      initialImageIndex,
    } = this.state

    return (
      <div>
        <p>
          Her kan du se bilder fra nærområde for å finne ut av om du kan ta
          bilde av noe for opplasting til bildebanken.
        </p>

        <div className="select-season">
          <h3>Vis:</h3>

          <Radio.Group
            value={this.props.season}
            disabled={this.props.loading}
            onChange={(e) => {
              this.handleSearchChange({season: e.target.value})
            }}
            options={SEASONS}
          />
        </div>

        <div className="search-field">
          <Input.Search
            size="large"
            placeholder="Søk etter sted eller landemerke"
            value={this.props.search}
            onChange={e => this.handleSearchChange({search: e.target.value})}
          />
        </div>

        <RenderPhotos
          photos={this.props.photos}
          onPhotoClick={this.photoClicked.bind(this)}
        />

        {this.props.noMoreResults && (
          <div>Ingen flere sider</div>
        )}

        {!this.props.noMoreResults && this.props.photos.length > 0 && (
          <Button
            type="primary"
            disabled={this.props.loading}
            onClick={() => this.fetchMorePhotos()}
          >
            Vis flere bilder
          </Button>
        )}


        {isFullscreen && (
          <PhotoGallery
            images={this.getGalleryImages()}
            initialImageIndex={initialImageIndex}
            onCloseRequest={this.closeFullscreen}
          />
        )}
      </div>
    )
  }
}

AreaPhotosView.propTypes = {
  photos: PropTypes.array.isRequired,
  search: PropTypes.string,
  season: PropTypes.string,
  loading: PropTypes.bool,
  noMoreResults: PropTypes.bool,
  updatePhotoSearch: PropTypes.func,
  onLoadMore: PropTypes.func,
}

export default AreaPhotosView
